var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 15,
  viewBox: "0 0 60 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.254 0A3.737 3.737 0 0 1 15 3.746v7.508A3.737 3.737 0 0 1 11.254 15H3.746A3.737 3.737 0 0 1 0 11.254V3.746A3.737 3.737 0 0 1 3.746 0zm22.5 0A3.737 3.737 0 0 1 37.5 3.746v7.508A3.737 3.737 0 0 1 33.754 15h-7.508a3.737 3.737 0 0 1-3.746-3.746V3.746A3.737 3.737 0 0 1 26.246 0zm22.5 0A3.737 3.737 0 0 1 60 3.746v7.508A3.737 3.737 0 0 1 56.254 15h-7.508A3.737 3.737 0 0 1 45 11.254V3.746A3.737 3.737 0 0 1 48.746 0z"
})));
export default SvgChannelMore;